// blog top table start
function topTable(){
    if($('.blog-top-table-list').css("display")=="block"){
      $('.blog-table-icon').prop("src","https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-blog-table-down-icon-small.png?v=1616569553");
    }else{
      $('.blog-table-icon').prop("src","https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-blog-table-up-icon-small.png?v=1616569553");
    };
    $('.blog-top-table-list').slideToggle();
  }
  // blog top table end
  